import React, { createContext, useContext, useEffect, useState } from 'react';
import { BasicInfoModel } from 'src/models/customer/basicInfoModel';
import { CustomerAddresseServicess } from 'src/services/customer/addresseServices';
import { CustomerCarService } from 'src/services/customer/customerCarService';
import { CustomerCartServicess } from 'src/services/customer/customerCartServices';
import { useCustomerData } from './customerData';
import {
  CustomerAddressesModel,
  CustomerAddressesArrayModel
} from 'src/models/customer/addressesModel';
import { CustomerCarModel } from 'src/models/customer/customerCarModel';
import { BookingsModel } from 'src/models/customer/bookingModel';
import { CustomerBookingServicess } from 'src/services/customer/bookingServices';
import { TimeSlotModel } from 'src/models/customer/timeSlotModel';
import { CommunicationModel } from 'src/models/customer/communication';
import { CommunicationService } from 'src/services/customer/communication';
import {
  CartSubscriptionModel,
  CustomerCartModel
} from 'src/models/customer/cartModel';

interface CustomerBookingCartContextValue {
  setSelectedCustomer: (data: BasicInfoModel | undefined) => void;
  handleGetCustomerBookingsById: (get?: string) => void;
  handleGetCustomerAddressById: (get?: string) => void;
  handleGetCustomerCarById: (get?: string) => Promise<CustomerCarModel[]>;
  handleGetAllCustomerCarsById: (get?: string) => void;
  handleGetCustomerCommunicationById: (get?: string) => void;
  selectedCustomerData: BasicInfoModel | undefined;
  setOpenAddBookingPage: (data: boolean) => void;
  setCartCards: (data: any | undefined) => void;
  setSubscriptionCards: (data: any | undefined) => void;
  handleGetCartData: (get?: string) => void;
  handleGetCartSubscriptions: (get?: string) => void;
  handleGetCart: () => void;
  setChangeData: (data: boolean) => void;
  setUpdateData: (data: boolean) => void;
  setExpandedCards: (data: any) => void;
  setGotDataOf: (data: any[]) => void;
  setGetData: (data: boolean) => void;
  refreshBookingList: () => void;
  refreshCartData: () => void;
  addressList: CustomerAddressesModel;
  setCartId: (data: number) => void;
  bookingList: BookingsModel[];
  openAddBookingPage: boolean;
  oldCartDelete: () => void;
  expandedCards: any[];
  cartCardsData: any[];
  updateData: boolean;
  changeData: boolean;
  GotDataOf: any[];
  getData: boolean;
  carList: any[];
  CartId: number;
  communicationList: CommunicationModel[];
  allCarList: any[];
  subscriptionCards: any[];
  cart: CustomerCartModel;
}

const CustomerBookingCartContext = createContext<
  CustomerBookingCartContextValue | undefined
>(undefined);

export const useCustomerBookingCart = () => {
  const context = useContext(CustomerBookingCartContext);
  if (!context) {
    throw new Error(
      'useCustomerBookingCart must be used within a CustomerBookingCartProvider'
    );
  }
  return context;
};

export const CustomerBookingCartProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [selectedCustomerData, setSelectedCustomerData] = useState<
    BasicInfoModel | undefined
  >();
  const { allServices, allTimeSlots, allPackages } = useCustomerData();

  const [getData, setGetData] = useState(false);
  const [cart, setCart] = useState<CustomerCartModel | null>(null);
  const [cartCardsData, setCartCardsData] = useState<any | undefined>([]);
  const [cartData, setCartData] = useState<any | undefined>([]);
  const [carList, setCarList] = useState([]);
  const [allCarList, setAllCarList] = useState([]);
  const [addressList, setAddressList] = useState<CustomerAddressesModel>();
  const [updateData, setUpdateData] = useState(false);
  const [openAddBookingPage, setOpenAddBookingPage] = useState(false);
  const [expandedCards, setExpandedCards] = useState([]);
  const [CartId, setCartId] = useState(0);
  const [changeData, setChangeData] = useState(true);
  const [bookingList, setBookingList] = useState<BookingsModel[]>();
  const [GotDataOf, setGotDataOf] = useState([]);
  const [communicationList, setCommunicationList] = useState([]);
  const [subscriptionCards, setSubscriptionCards] = useState<any | undefined>(
    []
  );

  const handleGetCustomerBookingsById = async (get?) => {
    let BookingGet: BookingsModel[];
    if (
      (!GotDataOf.includes('Bookings') || get === 'Get') &&
      selectedCustomerData?.id &&
      selectedCustomerData.id !== 0
    ) {
      try {
        const BookingGet = await CustomerBookingServicess.getData(selectedCustomerData.id);
        setBookingList(BookingGet);
        setGotDataOf((prevData) => [...new Set([...prevData, 'Bookings'])]);
      } catch (error) {
        console.error('Error fetching bookings:', error);
      }
    }
  };

  const handleGetCustomerAddressById = async (get?) => {
    let addressListGet: CustomerAddressesModel;

    if (!GotDataOf.includes('AddressList') || get === 'Get') {
      try {
        addressListGet = await CustomerAddresseServicess.getAllData(
          selectedCustomerData.id
        );
        setAddressList(addressListGet);
        setGotDataOf((prevData) => [...new Set([...prevData, 'AddressList'])]);
      } catch (error) {
        console.error('Error fetching address list:', error);
      }
    }

    if (get === 'Get') {
      const updatedCartCards = cartCardsData.map((card) => {
        if (card.selectedAddress) {
          return {
            ...card,
            cityId: selectedCustomerData.city.id,
            address: addressListGet?.addresses?.filter(
              (x) => x?.cityID === selectedCustomerData.city.id
            )
          };
        } else {
          const matchedAddress = addressListGet?.addresses?.find(
            (c) => c.addressId === card.address?.addressId
          );
          return {
            ...card,
            address: matchedAddress || card.address,
          };
        }
      });

      setCartCards(updatedCartCards);

      const updatedSubscriptionCards = subscriptionCards.map((card) => {
        if (card.selectedAddress) {
          return {
            ...card,
            address: addressListGet.addresses.filter(
              (x) => x?.cityID === selectedCustomerData.city.id
            )
          };
        } else {
          const matchedAddress = addressListGet?.addresses?.find(
            (c) => c.addressId === card.address?.addressId
          );
          return {
            ...card,
            address: matchedAddress || card.address,
          };
        }
      });
      setSubscriptionCards(updatedSubscriptionCards);
    }
  };

  const handleGetCustomerCarById = async (get?) => {
    if (!selectedCustomerData || selectedCustomerData.id === 0) return carList;

    try {
      const carsListGet = await CustomerCarService.getAllData(
        selectedCustomerData.id
      );
      const cars = carsListGet.cars || [];
      setCarList(cars);
      setGotDataOf(prev => [...new Set([...prev, 'CarList'])]);
      return cars;
    } catch (error) {
      console.error('Error fetching car list:', error);
      return carList;
    }
  };
  const handleGetAllCustomerCarsById = async (get?) => {
    let carsListGet: CustomerCarModel;

    if (!GotDataOf.includes('CarList') || get === 'Get') {
      try {
        carsListGet = await CustomerCarService.getAllCarsData(
          selectedCustomerData.id
        );
        setAllCarList(carsListGet.cars);
        setGotDataOf((prevData) => [...new Set([...prevData, 'CarList'])]); // Use new Set() to remove duplicates
      } catch (error) {
        console.error('Error fetching car list:', error);
      }
    }
  };

  const handleGetCart = async () => {
    try {
      const cartData = await CustomerCartServicess.getData(selectedCustomerData.id);
      setCart(cartData);
      setCartId(cartData.cartId || 0);
    } catch (error) {
      console.error('Error fetching cart data', error);
      setCart(null);
      setCartId(0);
    }
  };

  const handleGetCartData = async (get?) => {
    let addressListGet: CustomerAddressesModel;
    let carsListGet: CustomerCarModel;
    let timeSlots: TimeSlotModel[] = allTimeSlots;
    let gotCar;
    let cartDataGet;

    if (!GotDataOf.includes('CartData') || get === 'Get') {
      try {
        if (!GotDataOf.includes('AddressList')) {
          addressListGet = await CustomerAddresseServicess.getAllData(
            selectedCustomerData.id
          );
          setAddressList(addressListGet);
          setGotDataOf((prevData) => [...new Set([...prevData, 'AddressList'])]);
        } else {
          addressListGet = addressList;
        }

        if (!GotDataOf.includes('CarList')) {
          carsListGet = await CustomerCarService.getAllData(
            selectedCustomerData.id
          );
          gotCar = carsListGet.cars;
          setCarList(carsListGet.cars);
          setGotDataOf((prevData) => [...new Set([...prevData, 'CarList'])]);
        } else {
          gotCar = carList;
        }

        cartDataGet = await CustomerCartServicess.getData(
          selectedCustomerData.id
        );
        setCartData(cartDataGet);

        if (
          cartDataGet &&
          cartDataGet.cartServices.length > 0 &&
          addressListGet.addresses.length > 0 &&
          gotCar.length > 0
        ) {
          setCartId(cartDataGet.cartId);

          const CreatChanges = cartDataGet.cartServices.map((Card) => {
            const address = addressListGet.addresses.find(
              (x) => x.addressId === Card.customerAddressId
            );
            const car = gotCar.find((x) => x.customerCarId === Card.customerCarId);

            return {
              id: `card${Card.cartServiceId}`,
              cartId: Card.cartId,
              cityId: address?.cityID,
              areaId: address?.areaID,
              car,
              address,
              services: [],
              totalDiscount: 0,
              totalTax: 0,
              totalAmount: 0,
              selectedCar: !!car,
              selectedAddress: !!address
            };
          });

          for (const item of CreatChanges) {
            const relatedServices = cartDataGet.cartServices.filter(
              (service) => service.customerCarId === item.car?.customerCarId
            );

            item.services = relatedServices.map((service, index) => ({
              id: index + 1,
              cartServiceId: service.cartServiceId,
              serviceId: service.serviceId,
              serviceName: allServices.find((x) => x.id === service.serviceId)?.name,
              serviceDescription: allServices.find((x) => x.id === service.serviceId)?.shortDescription,
              date: service.date.split('T')[0],
              timeSlotId: service.timeSlotId,
              timeSlot: `${timeSlots.find((x) => x.id === service.timeSlotId)?.startTime} - ${timeSlots.find((x) => x.id === service.timeSlotId)?.endTime}`,
              price: service.price,
              taxRate: service.taxRate,
              taxAmount: service.taxAmount,
              discountRate: service.discountRate,
              discountAmount: service.discountAmount,
              finalAmount: service.finalAmount,
              note: service.note
            }));

            item.totalAmount = relatedServices.reduce((sum, s) => sum + s.finalAmount, 0);
            item.totalDiscount = relatedServices.reduce((sum, s) => sum + s.discountAmount, 0);
            item.totalTax = relatedServices.reduce((sum, s) => sum + s.taxAmount, 0);
          }

          const groupedServices = {};
          for (const item of CreatChanges) {
            const key = `${item.car.customerCarId}-${item.address.addressId}`;
            if (!groupedServices[key]) {
              groupedServices[key] = item;
            }
          }

          const finalChanges = Object.values(groupedServices);

          if (finalChanges.length > 0) {
            setCartCards(finalChanges);
          }
          else {
            setCartCards([
              {
                id: `card1`,
                cityId: selectedCustomerData?.city.id,
                areaId: selectedCustomerData?.area.id,
                car: gotCar,
                address: addressListGet.addresses.filter(
                  (x) => x.cityID === selectedCustomerData.city.id
                ) || [],
                services: [],
                totalDiscount: 0,
                totalTax: 0,
                totalAmount: 0,
                selectedCar: true,
                selectedAddress: true
              }
            ]);
          }

          setExpandedCards([false]);
          setChangeData(false);
        } else {
          setCartCards([
            {
              id: `card1`,
              cityId: selectedCustomerData?.city.id,
              areaId: selectedCustomerData?.area.id,
              car: gotCar,
              address: addressListGet?.addresses?.filter(
                (x) => x.cityID === selectedCustomerData.city.id
              ) || [],
              services: [],
              totalDiscount: 0,
              totalTax: 0,
              totalAmount: 0,
              selectedCar: true,
              selectedAddress: true
            }
          ]);
          setExpandedCards([false]);
          setChangeData(false);
        }

        setGotDataOf((prevData) => [...new Set([...prevData, 'CartData'])]);
      } catch (error) {
        console.error('Error fetching data from the API:', error);
      }
    }
  };

  const handleGetCartSubscriptions = async (get?) => {
    let addressListGet: CustomerAddressesModel;
    let carsListGet: CustomerCarModel;
    let timeSlots: TimeSlotModel[] = allTimeSlots;
    let gotCar;
    let cartDataGet;

    let finalSubscriptionCards = [];

    if (!GotDataOf.includes('CartData') || get === 'Get') {
      if (!GotDataOf.includes('AddressList')) {
        addressListGet = await CustomerAddresseServicess.getAllData(
          selectedCustomerData.id
        );
        setAddressList(addressListGet);
        setGotDataOf((prevData) => [...new Set([...prevData, 'AddressList'])]);
      } else {
        addressListGet = addressList;
      }

      if (!GotDataOf.includes('CarList')) {
        carsListGet = await CustomerCarService.getAllData(
          selectedCustomerData.id
        );
        gotCar = carsListGet.cars;
        setCarList(carsListGet.cars);
        setGotDataOf((prevData) => [...new Set([...prevData, 'CarList'])]);
      } else {
        gotCar = carList;
      }

      cartDataGet = await CustomerCartServicess.getData(
        selectedCustomerData.id
      );
      setCartData(cartDataGet);

      const cartSubscriptions = cartDataGet?.cartSubscriptions ?? [];

      if (
        cartDataGet &&
        cartDataGet.cartSubscriptions &&
        cartDataGet.cartSubscriptions.length > 0 &&
        addressListGet.addresses.length > 0 &&
        gotCar.length > 0
      ) {
        setCartId(cartDataGet.cartId);

        finalSubscriptionCards = cartDataGet.cartSubscriptions.map((sub: CartSubscriptionModel) => ({
          id: `subscription-${sub.cartSubscriptionId}`,
          cartSubscriptionId: sub.cartSubscriptionId,
          cartId: sub.cartId,
          customerCarId: sub.customerCarId,
          customerAddressId: sub.customerAddressId,
          packageId: sub.packageId,
          startDate: sub.startDate,
          endDate: sub.endDate,
          price: sub.price,
          taxRate: sub.taxRate,
          taxAmount: sub.taxAmount,
          discountRate: sub.discountRate,
          discountAmount: sub.discountAmount,
          finalAmount: sub.finalAmount,
          autoRenew: sub.autoRenew,
          car: gotCar.find((c) => c.customerCarId === sub.customerCarId),
          address: addressListGet.addresses.find(
            (a) => a.addressId === sub.customerAddressId
          ),
          package: allPackages?.find((p) => p.id === sub.packageId),
          preferredTimeSlotId: sub.preferredTimeSlotId,
          preferredTimeSlot: `${timeSlots?.find((x) => x.id === sub?.preferredTimeSlotId)?.startTime} - ${timeSlots?.find((x) => x.id === sub?.preferredTimeSlotId)?.endTime}`,
          selectedCar: true,
          selectedAddress: true,
          selectedPackage: true, 
          note: sub.note
        }));
        setSubscriptionCards(finalSubscriptionCards);
      }
    }
  };

  const handleGetCustomerCommunicationById = async (get?) => {
    let communicationListGet: CommunicationModel[];

    if (!GotDataOf.includes('CommunicationList') || get === 'Get') {
      try {
        communicationListGet = await CommunicationService.getData(
          selectedCustomerData.id
        );

        setCommunicationList(communicationListGet);
        setGotDataOf((prevData) => [
          ...new Set([...prevData, 'CommunicationList'])
        ]); // Use new Set() to remove duplicates
      } catch (error) {
        console.error('Error fetching car list:', error);
      }
    }
  };

  const oldCartDelete = (get?) => {
    setCartCards([
      {
        id: `card1`,
        cityId: selectedCustomerData?.city.id,
        areaId: selectedCustomerData?.area.id,
        car: carList,
        address:
          addressList.addresses.filter(
            (x) => x?.cityID === selectedCustomerData.city.id
          ) || [],
        services: [],
        totalDiscount: 0,
        totalTax: 0,
        totalAmount: 0,
        selectedCar: true,
        selectedAddress: true
      }
    ]);
    setExpandedCards([false]);
  };

  const setSelectedCustomer = (data: BasicInfoModel | undefined) => {
    
    if (!data || (selectedCustomerData && data.id !== selectedCustomerData.id)) {
      setCarList([]);
      setAllCarList([]);
      setAddressList(undefined);
      setBookingList(undefined);
      setCommunicationList([]);
      setGotDataOf([]);
      setCartCardsData([]);
      setSubscriptionCards([]);
      setCart(null);
    }
    setSelectedCustomerData(data);
  };

  useEffect(() => {
    return () => {
      setSelectedCustomerData(undefined);
      setCarList([]);
      setAllCarList([]);
    };
  }, []);

  const setCartCards = (data: any | undefined) => {
    setCartCardsData(data);
  };

  const refreshBookingList = () => {
    // Reset GotDataOf for Bookings to force refetch
    setGotDataOf(prev => prev.filter(item => item !== 'Bookings'));
    handleGetCustomerBookingsById('Get');
  };

  const refreshCartData = async () => {
    await handleGetCart();
    await handleGetCartData('Get');
  }

  return (
    <CustomerBookingCartContext.Provider
      value={{
        handleGetCustomerBookingsById,
        handleGetCustomerAddressById,
        handleGetCustomerCarById,
        handleGetAllCustomerCarsById,
        handleGetCustomerCommunicationById,
        setOpenAddBookingPage,
        selectedCustomerData,
        setSelectedCustomer,
        openAddBookingPage,
        handleGetCartData,
        setExpandedCards,
        setChangeData,
        setGotDataOf,
        setUpdateData,
        expandedCards,
        cartCardsData,
        setCartCards,
        oldCartDelete,
        addressList,
        bookingList,
        updateData,
        changeData,
        setGetData,
        GotDataOf,
        setCartId,
        getData,
        carList,
        communicationList,
        CartId,
        allCarList,
        subscriptionCards,
        handleGetCartSubscriptions,
        setSubscriptionCards,
        handleGetCart,
        cart,
        refreshBookingList,
        refreshCartData
      }}
    >
      {children}
    </CustomerBookingCartContext.Provider>
  );
};
